import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import ModalHoc from '../../../../../../Ui/Modal/ModalHoc';
import RfpMemberAddModalForm from './RfpMemberAddModalForm';
const RfpMemberAddModal = (props) => {
    const { kanaRef, modalState, onCancel, onSubmit } = props;
    return (_jsxs("div", Object.assign({ className: `rfp-card-modal-background animated-opacity ${modalState}` }, { children: [_jsx("div", { className: 'rfp-card-modal-background-bg', onClick: onCancel, role: 'presentation' }), _jsxs("div", Object.assign({ className: 'rfp-card is-rfp is-modal rfp-card-add-member' }, { children: [_jsx("div", Object.assign({ className: 'rfp-card-head' }, { children: _jsx("span", { children: "\u63D0\u6848\u8CC7\u6599\u306E\u5171\u6709\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u3059\u308B" }) })), _jsx("div", Object.assign({ className: 'rfp-card-body' }, { children: _jsx("div", Object.assign({ className: 'rfp-card-form' }, { children: _jsx(RfpMemberAddModalForm, { kanaRef: kanaRef, onCancel: onCancel, onSubmit: onSubmit }) })) }))] }))] })));
};
RfpMemberAddModal.propTypes = {
    kanaRef: propShape().isRequired,
    modalState: propStr().isRequired,
    onCancel: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
};
const enhance = compose(ModalHoc);
export default enhance(RfpMemberAddModal);
